import { sortedUniq } from 'lodash';

const uniqueSortedArray = arr => {
  const sorted = arr.sort((a, b) => a - b);
  return sortedUniq(sorted);
};


export default uniqueSortedArray;
